export default '/Users/vivek/Desktop/workplace/portone-js/node_modules/js-nacl/lib'